export const STATUS_BADGE_CLASS = 'px-8 py-5 rounded-lg font-semibold whitespace-nowrap';
export const STATUS_CELL_CLASS = 'inline-flex flex-col text-12 px-8 py-5 rounded-lg';

export const DYNAMIC_VALIDATION_STATE_META = {
    CONVERGED: { label: 'Converged', color: 'green' },
    TERMINATED: { label: 'Terminated', color: 'yellow' },
    NOT_CONVERGED: { label: 'Not converged', color: 'red' },
    NOT_FINISHED: { label: 'Not finished', color: 'gray' },
    RUNNING: { label: 'Running', color: 'yellow' }
};

export const DYNAMIC_VALIDATION_DETAIL_GROUP_META = {
    base_values: { label: 'Base values', filename: 'base-values' },
    best_values: { label: 'Best values', filename: 'best-values' },
    variables_to_monitor: { label: 'Monitor variables', filename: 'monitor-variables' },
    alarm_variables: { label: 'Alarm variables', filename: 'alarm-variables' }
};